import script from "./BuildingList.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuildingList.vue?vue&type=script&setup=true&lang=ts"

import "./BuildingList.vue?vue&type=style&index=0&id=0a3bf423&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a3bf423"]])

export default __exports__